module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://under-construction.club"
    }
  }, [_c('svg', {
    attrs: {
      "href": "https://under-construction.club",
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 154.35 101.03"
    }
  }, [_c('path', {
    staticClass: "cls-1 sign-inner",
    attrs: {
      "d": "M50.51,101a5.89,5.89,0,0,1-4.19-1.74L1.81,54.7a5.93,5.93,0,0,1,0-8.38L46.33,1.81a5.92,5.92,0,0,1,8.38,0L99.22,46.33a5.92,5.92,0,0,1,0,8.38L54.7,99.22A5.88,5.88,0,0,1,50.51,101Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.51.15a5.81,5.81,0,0,1,4.14,1.71L99.17,46.38a5.85,5.85,0,0,1,0,8.27L54.65,99.17a5.85,5.85,0,0,1-8.27,0L1.86,54.65a5.85,5.85,0,0,1,0-8.27L46.38,1.86A5.81,5.81,0,0,1,50.51.15m0-.15a6,6,0,0,0-4.24,1.76L1.76,46.27a6,6,0,0,0,0,8.49L46.27,99.27a6,6,0,0,0,8.49,0L99.27,54.76a6,6,0,0,0,0-8.49L54.76,1.76A6,6,0,0,0,50.51,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-1 sign-inner",
    attrs: {
      "d": "M50.51,96.78a5.71,5.71,0,0,1-4.07-1.68L5.93,54.58a5.76,5.76,0,0,1,0-8.13L46.45,5.93a5.75,5.75,0,0,1,8.13,0L95.1,46.45a5.75,5.75,0,0,1,0,8.13L54.58,95.1A5.71,5.71,0,0,1,50.51,96.78Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M50.51,4.5A5.46,5.46,0,0,1,54.4,6.11L94.92,46.63a5.51,5.51,0,0,1,0,7.78L54.4,94.92a5.5,5.5,0,0,1-7.78,0L6.11,54.4a5.5,5.5,0,0,1,0-7.78L46.63,6.11A5.46,5.46,0,0,1,50.51,4.5m0-.5a6,6,0,0,0-4.24,1.76L5.76,46.27a6,6,0,0,0,0,8.49L46.27,95.27a6,6,0,0,0,8.49,0L95.27,54.76a6,6,0,0,0,0-8.49L54.76,5.76A6,6,0,0,0,50.51,4Z"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "cls-2",
    attrs: {
      "transform": "translate(15.05 57.81)"
    }
  }, [_vm._v("UnderCon\n            "), _c('tspan', {
    staticClass: "cls-3",
    attrs: {
      "x": "58.94",
      "y": "0"
    }
  }, [_vm._v("s")]), _vm._v(" "), _c('tspan', {
    staticClass: "cls-4",
    attrs: {
      "x": "65.16",
      "y": "0"
    }
  }, [_vm._v("tru")]), _vm._v(" "), _c('tspan', {
    staticClass: "cls-5",
    attrs: {
      "x": "81.75",
      "y": "0"
    }
  }, [_vm._v("c")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "88.5",
      "y": "0"
    }
  }, [_vm._v("tionClub")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d88a68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/logo.vue
// module id = 32
// module chunks = 1